import { render, staticRenderFns } from "./VersionInput.vue?vue&type=template&id=1d373109&"
import script from "./VersionInput.vue?vue&type=script&lang=ts&"
export * from "./VersionInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports